<template>
  <div class="content">
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-7 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor}} </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-5 col-5 text-right">
          <base-button v-if="$can('update', 'garantias')" size="sm" type="neutral"  @click="$emit('showModalCreatePlan', 'create', 0)">Ingresar nueva garantía</base-button>
          <!--<base-button size="sm" type="neutral">Filters</base-button>-->
          <base-button size="sm" type="neutral" @click="getReporte" >Descargar Reporte</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Sucursal: {{$store.state.user.sponsor_branch}}</h3>
            <p class="text-sm mb-0">
              
            </p>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Realizar búsqueda...">
                </base-input>
              </div>
              
              
            </div>
            <div class="table-responsive">
              <el-table :data="queriedData"
                        row-key="id"
                        class="table-responsive table"
                        header-row-class-name="thead-light"
                        @sort-change="sortChange"
                        @selection-change="selectionChange">
              
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                  :width="column.type == 'selection' ? '40px' : (column.label == 'id' ? '90px' : '200px')"
                >
                </el-table-column>

                <el-table-column label="Glosa" width="180">
                  <template #default="scope">              
                  {{scope.row.note.slice(0, 40) + (scope.row.note.length > 40 ? '...' : '') }}
                  <span style="display:none" >{{scope.row.note}}</span> 
                  </template>
              </el-table-column>


                <el-table-column min-width="100px" align="right" label="Endosos">

                  <div slot-scope="{$index, row}" class="d-flex">
                        <base-button
                        @click.native="handleViewEndoso($index, row)"
                        class="view"
                        type="info"
                        size="sm"
                        icon
                        v-if="row.guarantee_count > 0"
                      >
                        <i class="text-white ni ni ni-tag"></i>
                      </base-button>

                  </div>
                </el-table-column>
                <el-table-column min-width="180px" align="right" label="Acciones">
                  <div slot-scope="{$index, row}" class="d-flex">


                    

                     <base-button
                      @click.native="handleView($index, row)"
                      class="view"
                      type="default"
                      size="sm"
                      icon
                    >
                      <i class="text-white ni ni ni-app"></i>
                    </base-button>

                    <base-button
                      @click.native="handleEdit($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                      v-if="$can('update', 'garantias')"
                    >
                      <i class="text-white ni ni ni-badge"></i>
                    </base-button>
                    <base-button
                      @click.native="handleDelete($index, row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                       v-if="$can('update', 'garantias')"
                    >
                      <i class="text-white ni ni-fat-remove"></i>
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando desde {{ from + 1 }} al {{ to }} de un total de {{ total }} registros

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} registros seleccionados
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
      <!--Nuevo usuario Modal-->
      <form-create-plan @successSending="fetchData" no-close-on-backdrop></form-create-plan>
      <edit-plan @successSending="fetchData" no-close-on-backdrop></edit-plan>
    </div></div>
</template>
<script>
import { Table, TableColumn, Select, Option, Input } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
import swal from 'sweetalert2';
import { Modal, BaseAlert } from '@/components';
import FormCreatePlan from './FormCreateGuarantee';
import EditPlan from './EditGuarantee';

import Fuse from 'fuse.js';

export default {
  mixins: [clientPaginationMixin],
  // En este mixins esta el atributo que se encarga del tamaño de la pagina
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [Input.name]: Input,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
    FormCreatePlan,
    EditPlan
  },
  data() {
    return {
      propsToSearch: ['nombre', 'id'],
      tableColumns: [
      ],
      tableData: [],
      selectedRows: [],
      
    };
  },
  methods: {
    handleView(index, row) {
     console.log('el index es: ', index, ' y el row.id es: ', row.id);
     this.$emit('showModalCreatePlan','view', row.id);
    },
    handleViewEndoso(index, row) {
     console.log('el index es: ', index, ' y el row.policy es: ', row.policy);
     this.searchQuery = row.policy;
    },
    handleEdit(index, row) {
     console.log('el index es: ', index, ' y el row.id es: ', row.id);
     this.$emit('showModalCreatePlan','edit', row.id);
    },
    handleDelete(index, row) {
      swal({
        title: 'Estás seguro?',
        text: `Estás seguro de eliminar la garantía ${row.id}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Si',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          var vm = this;
          
          console.log(row);
          this.axios({
            url: 'api/guarantees/'+row.id,
            method: 'DELETE',
          }).then( response => {
            vm.deleteRow(row);
            swal({
              title: 'Garantía Eliminada!',
              text: `Has eliminado la garantía ${row.id}`,
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            });
          }).catch( error => {
            console.log(error);
            vm.$notify({ type: 'danger', message: error.response.data});
          });
          
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    fetchData()
    {
      var vm = this;
      this.axios({
        url: 'api/guarantees',
        method: 'GET',

      }).then( response => {
        console.log(response.data);
        let columnas;
        if( response.data.data.length > 0 ) columnas = Object.getOwnPropertyNames(response.data.data[0]);
        vm.tableData = response.data.data;
        vm.propsToSearch = columnas;
        vm.tableColumns = [];
        //vm.tableColumns.push({ type: 'selection' });


       

        columnas.forEach( item => {
          vm.tableColumns.push({ prop: item, label: item, sortable: true });
        } );

         vm.tableColumns = [
          { prop: "id", label: "ID", sortable: true },
          { prop: "document", label: "Tipo Documento" },
          { prop: "topic_name", label: "Ramo" },
          { prop: "coverage_name", label: "Cobertura" },
          { prop: "contractor_name", label: "Contratante" },
          { prop: "contractor_dni", label: "Rut Contratante" },
          { prop: "insured_name", label: "Asegurado" },
          { prop: "insured_dni", label: "Rut Asegurado" },
          { prop: "policy", label: "Póliza" },
          
          { prop: "company_name", label: "Compañía" },
          { prop: "issue_date", label: "Fecha Emision" },
          { prop: "start_date", label: "Fecha Inicio" },
          { prop: "end_date", label: "Fecha Término" },
          { prop: "updated_end_date", label: "Fecha Término Actualizada" },
          { prop: "currency_name", label: "Moneda" },
          { prop: "insured_amount", label: "Monto Asegurado" },
          { prop: "insured_amount_updated", label: "Monto Asegurado Actualizado" },
          { prop: "premium", label: "Prima neta" },
   
          { prop: "consultant", label: "Consultor" },

          { prop: "sponsor_name", label: "Sponsor" },
      


        ];

        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3,
          distance: 3000
         });


      }).catch( error => {
        console.log('Error al ir  a buscar los usuarios');
        console.log(error); 
      })
    },
    openModalNuevoUsuario(){
      this.$emit
    },

    getReporte()
      {
        var vm = this;
    
          
             
 
                    this.axios({
                        url: 'api/guarantees/reporte',
                        method: 'POST',
                        data: {
                            // company: vm.inputs.compañia,
                            // range: vm.inputs.rango.split(" a "),
                            // sponsor: vm.inputs.sponsor
                        },
                        responseType: 'blob', // important
                        headers: { 'Accept': 'application/vnd.ms-excel' },
                    }).then( response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    }).catch( error => {
                        if( error.response.status == 422){
                            Object.entries(error.response.data.errors).forEach( elem => {
                                vm.$notify({
                                    message: elem[1][0],
                                    timeout: 5000,
                                    icon: 'ni ni-bell-55',
                                    type: 'danger'
                                });
                            });
                        }else{
                            console.log(error);
                            vm.$notify({
                                message: 'Hubo un error, no se pudo realizar la consulta',
                                timeout: 5000,
                                icon: 'ni ni-bell-55',
                                type: 'default'
                            });
                        }
                    });
                

                    
       
 
      },


  },
  mounted(){
    this.fetchData();
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
